import Translator from "./translator";
import { CancelablePromise as Promise } from "./cancelablePromise";
import { ViolationValidationResult } from "./violations";

export class InOrNearViolationValidationResult extends ViolationValidationResult {
    constructor (private readonly violationName: string, private readonly violationHours: string[], readonly timeLeft: number) {
        super();
    }

    getMessage() {
        // Not used
        return Promise.resolve("");
    }

    getNoticeBoxMessage(translator: Translator) {
        let timeLeftString = "{0} left";
        return this.translate(translator, [this.violationName, timeLeftString, this.hoursKey, this.minutesKey])
            .then(([violationName, timeLeftMsg, translatedHours, translatedMinutes]) => {
                let violationAlertString = violationName;
                this.violationHours.forEach((hours, index) => {
                    violationAlertString = violationAlertString.replace(`{${ index }}`, hours);
                });
                let formattedDuration = this.getFormattedTimeString(this.timeLeft, translatedHours, translatedMinutes.replace("{minutes}", ""));
                let timeLeftFormattedMsg = timeLeftMsg.replace("{0}", formattedDuration);

                return `<span>${ timeLeftFormattedMsg }: ${ violationAlertString }</span>`;
            });
    }
}